import React from 'react';

const SvgChartIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.875 4.33325H21.125V21.6666H17.875V4.33325ZM4.875 15.1666H8.125V21.6666H4.875V15.1666ZM11.375 9.74992H14.625V21.6666H11.375V9.74992Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgChartIcon;
